var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfflineMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.1998H6.21C2.41 18.1998 1.25 17.0398 1.25 13.2398V7.23979C1.25 3.43979 2.41 2.27979 6.21 2.27979H16.74C20.54 2.27979 21.7 3.43979 21.7 7.23979C21.7 7.64979 21.36 7.98979 20.95 7.98979C20.54 7.98979 20.2 7.64979 20.2 7.23979C20.2 4.29979 19.68 3.77979 16.74 3.77979H6.21C3.27 3.77979 2.75 4.29979 2.75 7.23979V13.2398C2.75 16.1798 3.27 16.6998 6.21 16.6998H10C10.41 16.6998 10.75 17.0398 10.75 17.4498C10.75 17.8598 10.41 18.1998 10 18.1998Z",
    fill: "#3E485B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.7199C9.59 22.7199 9.25 22.3799 9.25 21.9699V17.4399C9.25 17.0299 9.59 16.6899 10 16.6899C10.41 16.6899 10.75 17.0299 10.75 17.4399V21.9699C10.75 22.3899 10.41 22.7199 10 22.7199Z",
    fill: "#95A3B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.2002H2C1.59 14.2002 1.25 13.8602 1.25 13.4502C1.25 13.0402 1.59 12.7002 2 12.7002H10C10.41 12.7002 10.75 13.0402 10.75 13.4502C10.75 13.8602 10.41 14.2002 10 14.2002Z",
    fill: "#3E485B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 22.7202H6.74023C6.33023 22.7202 5.99023 22.3802 5.99023 21.9702C5.99023 21.5602 6.33023 21.2202 6.74023 21.2202H10.0002C10.4102 21.2202 10.7502 21.5602 10.7502 21.9702C10.7502 22.3802 10.4102 22.7202 10.0002 22.7202Z",
    fill: "#95A3B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6633 16.5021C23.302 16.5819 22.9291 16.3775 22.8005 16.027C21.3403 11.9664 17.6186 9.58305 13.3109 9.97135C12.8998 10.011 12.5346 9.70243 12.495 9.2913C12.4554 8.88017 12.7639 8.51504 13.175 8.47542C18.1759 8.02617 22.5132 10.7856 24.2025 15.5125C24.3398 15.902 24.1386 16.3356 23.749 16.4729C23.7316 16.487 23.6926 16.4956 23.6633 16.5021Z",
    fill: "#95A3B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6129 18.2721C20.2516 18.3519 19.8788 18.1476 19.7502 17.797C18.7115 14.903 16.0529 13.2065 12.9906 13.4835C12.5795 13.5231 12.2143 13.2146 12.1747 12.8035C12.1351 12.3924 12.4436 12.0272 12.8548 11.9876C16.62 11.6475 19.8768 13.7341 21.1522 17.2825C21.2894 17.6721 21.0882 18.1057 20.6987 18.2429C20.6715 18.2592 20.6422 18.2657 20.6129 18.2721Z",
    fill: "#95A3B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0405 19.7163C16.6793 19.7961 16.3064 19.5917 16.1778 19.2412C15.7206 17.9596 14.5403 17.2065 13.1854 17.3317C12.7743 17.3713 12.4092 17.0628 12.3695 16.6517C12.3299 16.2405 12.6384 15.8754 13.0496 15.8358C15.0781 15.6539 16.9021 16.8179 17.5917 18.7343C17.729 19.1238 17.5277 19.5574 17.1382 19.6947C17.1089 19.7012 17.0796 19.7076 17.0405 19.7163Z",
    fill: "#95A3B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1023 10.1404L12.6315 17.5009",
    stroke: "#CAD1DE",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineMode);
export default __webpack_public_path__ + "static/media/offlineMode.7199fbb87b32ebddef48dd75912e2ecf.svg";
export { ForwardRef as ReactComponent };